import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Host,
  Input,
  Optional,
  SkipSelf,
} from '@angular/core';
import {
  ColumnBase,
  ColumnComponent,
  IdService,
} from '@progress/kendo-angular-grid';

@Component({
  selector: 'kendo-grid-column-ex',
  providers: [
    {
      provide: ColumnBase,
      useExisting: forwardRef(() => KendoGridColumnExComponent),
    },
  ],
  template: ``,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KendoGridColumnExComponent extends ColumnComponent {
  /*
  @Input('field') public field: string;
  */

  @Input('data-x') public dataX: unknown;

  constructor(
    el: ElementRef,
    @Optional() @Host() @SkipSelf() parent?: ColumnBase,
    @Optional() idService?: IdService
  ) {
    // NOTE: this hack was necessary as the data-* attributes does not work same way as other non data-* attributes with - in their name!
    super(parent, idService);
    this.dataX = el.nativeElement.getAttribute('data-x');
  }
}
